<template>
  <empty-state class="margin-auto mt-12">
    <template #icon>
      <v-icon size="80" icon="$backupAndRestoreL" />
    </template>
    <template #description>
      <span>{{ $t("cloudBackupAndRestore.emptyState.title") }}</span>
    </template>
    <template #subtitle>
      <span>{{ $t("cloudBackupAndRestore.emptyState.subtitle") }}</span>
    </template>
    <template #button>
      <v-btn
        color="primary"
        data-testid="backup-and-restore-activate-btn"
        rounded
        size="large"
        @click="activateBackupAndRestore()"
      >
        {{ $t("cloudBackupAndRestore.emptyState.activate") }}
      </v-btn>
    </template>
  </empty-state>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import EmptyState from "@/components/EmptyState.vue";
import ActivateBackupAndRestoreModal from "@/components/modals/msp/cloud-backup/ActivateBackupAndRestoreModal.vue";
import { useDialogsStore } from "@/_store/dialogs.module";
import { useMspCloudBackupStore } from "@/_store/msp-cloud-backup.module.ts";
import { componentDialogsConfigConstructor } from "@/_helpers/dialog-helpers";
import { BackupAndRestoreAction } from "@/constants/cloud-backup.ts";
import { ModalWidth } from "@/constants/modals";
import { SubscriptionModule } from "@/constants/workplaces.ts";
import { RolePermissionsScope } from "@/constants/roles.ts";
import { isMspActionRestricted } from "@/_helpers/msp-permissions.ts";

export default defineComponent({
  components: {
    EmptyState,
  },
  emits: ["activated"],
  setup(_props, { emit }) {
    const dialogsStore = useDialogsStore();
    const backupAndRestoreStore = useMspCloudBackupStore();

    const activateBackupAndRestore = () => {
      const dialogConfig = componentDialogsConfigConstructor({
        action: BackupAndRestoreAction.CREATE_MSP_ACCOUNT,
        component: ActivateBackupAndRestoreModal,
        width: ModalWidth.MEDIUM,
        callback: async (data) => {
          await backupAndRestoreStore.createMspAccount(data);
          // Re-fetch status so the page transitions NOT_CONNECTED -> CONNECTED.
          emit("activated");
        },
      });
      dialogsStore.openDialog({
        ...dialogConfig,
        disable: isMspActionRestricted(
          RolePermissionsScope.PROTECTION,
          SubscriptionModule.BACKUP_AND_RESTORE
        ),
      });
    };

    return {
      activateBackupAndRestore,
    };
  },
});
</script>

<style lang="scss" scoped></style>
